module.exports = __webpack_public_path__ + "static/media/bt-mic-on.2e10194d.svg";